import React from 'react'
import Image from 'next/image'
import { Column } from '@paper-monster/web/src/components/layout'
import moneyBackImg from '@paper-monster/web/src/assets/buy-flow/right-side/cc--money-back.png'
import taxImg from '@paper-monster/web/src/assets/buy-flow/right-side/cc--tax.png'
import communityImg from '@paper-monster/web/src/assets/buy-flow/right-side/cc--community.png'
import styles from '@paper-monster/web/src/components/blocks/CheckoutSideCreditCard.module.scss'

export default function CheckoutSideCreditCardNeatDocs() {
  return (
    <Column className={styles.background} gap={32} size={66}>
      <h1 className={styles.headLine}>You're almost ready to start with NeatDocs</h1>
      <ul className={styles.featuresList}>
        <li>
          <Image alt="" src={moneyBackImg} />
          30-day money-back guarantee if NeatDocs isn't right for you
        </li>
        <li>
          <Image alt="" src={taxImg} />
          The cost of NeatDocs is tax-deductible for businesses and the self-employed.
        </li>
        <li>
          <Image alt="" src={communityImg} />
          Trusted by 2 million+ small businesses for over 20 years.
        </li>
      </ul>
    </Column>
  )
}
